import * as React from 'react';
import * as style from './style.css';
import { FlatCard } from '../FlatCard';
import { jsx as _jsx } from "react/jsx-runtime";
export const FlatsList = _ref => {
  let {
    flats,
    favoriteButton,
    onFlatCardClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    id: "MvkFlatCards",
    "data-testid": "MvkFlatCards",
    children: flats.map(flat => /*#__PURE__*/_jsx(FlatCard, {
      favoriteButton: favoriteButton,
      flat: flat,
      onClick: onFlatCardClick
    }, flat.offerId))
  });
};